import { useCallback } from 'react';
import uuid from 'uuid/v1';
import { config as authConfig } from 'modules/taboola-common-frontend-modules/authentication';
import { authTokenManager } from 'modules/taboola-common-frontend-modules/authentication/services/AuthTokenManager';
import { useChatAgentContextService } from 'modules/taboola-common-frontend-modules/chat-agent/hooks/useChatAgentContextService';
import { config as logRocketConfig } from 'modules/taboola-common-frontend-modules/log-rocket';
import { config } from 'modules/taboola-common-frontend-modules/version';
import { getHashedToken } from '../../authentication/utils/auth-utils';
import { tabId } from '../tabId';

export const useAppEventExtension = () => {
    const { getContext } = useChatAgentContextService();

    const extend = useCallback(
        async event => {
            const data = {
                id: uuid(),
                timeStamp: new Date().toISOString(),
                appId: authConfig.getApplicationName(),
                tabId,
                sessionId: getHashedToken(authTokenManager.getToken()),
                logRocketSessionUrl: logRocketConfig.sessionUrl,
                feVersion: config.assetsVersion,
                gwVersion: config.gwVersion,
                rrand: event?.event?.rrand,
            };

            const context = await getContext(event);

            return { ...event, ...data, ...context };
        },
        [getContext]
    );

    return extend;
};
